module.exports = __webpack_public_path__ + "static/windowsdefendersmartscreen-a337f85427811a2eb03406347fa28ce3.png";